/**
 * Browser-safe import of pre-bundled tool specs.
 * 
 * This module provides a way to import pre-bundled specs that works with
 * both ES modules and build tools like Vite.
 * 
 * Vite will statically analyze the import and inline it at build time.
 * The build script ensures this file always exists (even if empty).
 */

import type { RawToolSpec } from "./specLoader";

/**
 * Pre-bundled tool specs.
 * This import will be statically analyzed by Vite and inlined at build time.
 * The generated file is created by the build script before building.
 * 
 * If the file doesn't exist, this import will fail at build time (which is desired).
 * For development, the build script should be run first.
 */
// @ts-ignore - file is generated by build script, may not exist at dev time
import { ALL_TOOL_SPECS } from "../generated/toolSpecs.js";

/**
 * Get pre-bundled tool specs.
 * Returns the pre-bundled specs array.
 */
export function getBundledSpecs(): RawToolSpec[] {
  // ALL_TOOL_SPECS is imported from the generated file
  // If the import fails, this will throw, which is handled by the caller
  return (ALL_TOOL_SPECS || []) as RawToolSpec[];
}

